<template>
  <div class="hdp-go-back-wrap">
    <div class="hdp-go-back" @click="$emit('route', route)"><img width="10" height="18" src="../assets/svg/arrow-back.svg"></div>
  </div>
</template>

<script>
export default {
  name: 'StepBack',

  props: {
    route: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
  .hdp-go-back {
    display: inline-block;
    width: 18px;
    height: 18px;
    padding: 5px;
    margin-right: 12px;
    border: 2px solid #7e98e5;
    border-radius: 50%;
    font-size: 0;
  }
  .hdp-go-back img {
    margin-left: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/StepBack.vue